import { z } from "zod";

/** CPF (11 digitos). Aceita formatado, normaliza para so digitos. */
export const cpfSchema = z
  .string()
  .trim()
  .transform((v) => v.replace(/\D/g, ""))
  .refine((v) => v.length === 11, "CPF deve ter 11 digitos");

/** CNPJ (14 digitos). Aceita formatado, normaliza para so digitos. */
export const cnpjSchema = z
  .string()
  .trim()
  .transform((v) => v.replace(/\D/g, ""))
  .refine((v) => v.length === 14, "CNPJ deve ter 14 digitos");

export const optionalCpfSchema = cpfSchema.optional().or(z.literal("").transform(() => undefined));
export const optionalCnpjSchema = cnpjSchema.optional().or(z.literal("").transform(() => undefined));
